// fetch
import { post } from './fetch.js';

// urls
import urls from './_services.json';

// util
import { getUrl } from './util.js';

/**
 * reportData
 * @param {*} data
 * @returns
 */
export async function reportData(data) {
  const url = getUrl(urls.reportData);
  return await post(url, data);
}
